<template>
  <loading-data-page-container :loading="loading"
                               :loading-error="loadingError"
                               :loading-error-message="loadingErrorMsg"
                               max-width
                               class="courtagen-page">

    <template v-if="!loading && !loadingError">

      <div class="ueberplus primary--text">Courtage-Abrechnungen</div>

      <template v-if="years.length !== 0">

        <template v-for="(year, index) in years">

          <div :key="year">

            <div :class="showYear(year) ? '' : 'table-hidden'"
                 class="semanticsection-title2 primary--text"
                 @click="shownYear = year">{{ year }}
            </div>

            <div v-if="showYear(year)" class="courtagen-table">

              <v-data-table :items="courtagenMap.get(year)"
                            hide-default-header
                            hide-default-footer
                            class="no--hover">

                <template v-slot:item="{item}">
                  <tr>
                    <td>{{ item.time | date }}</td>
                    <td class="courtage-link">
                      <a :href="item.url"
                         target="_blank" >Abrechnung anzeigen</a>
                      <v-icon>open_in_new</v-icon>
                    </td>
                  </tr>
                </template>

              </v-data-table>

            </div>

            <v-divider v-if="index < years.length -1" class="year-divider"/>

          </div>

        </template>

      </template>

      <template v-else>

        <div id="noDataText">Keine Courtage-Abrechnungen vorhanden</div>

      </template>

    </template>

  </loading-data-page-container>
</template>
<script>
import dummyData from '@/store/dummyData/courtagenDummyData';
import httpService from '@/helper/httpService';
import LoadingDataPageContainer from "@/components/kundenverwaltung/LoadingDataPageContainer";
import FiltersMixin from '@/components/kundenverwaltung/FiltersMixin';
import { CONNECTION_ERROR_MESSAGE } from "@/helper/httpService";

export default {
  name: "CourtagenPage",
  components: { LoadingDataPageContainer },
  mixins: [FiltersMixin],
  data () {
    return {
      loading: true,
      loadingError: false,
      loadingErrorMsg: '',
      courtagen: null,
      shownYear: ''
    };
  },
  computed: {
    courtagenMap () {
      let map = new Map();
      this.courtagen.map(this.formatData).forEach(function (c) {
        if (map.has(c.year)){
          map.get(c.year).push(c);
        } else {
          map.set(c.year, [c]);
        }
      });
      map.forEach(year => year.sort( (c1, c2) => c2.time - c1.time));
      return map;
    },
    years () {
      return [...this.courtagenMap.keys()].sort( (y1, y2) => +y2 - +y1 );
    }
  },
  created() {
    httpService.getCourtagen()
      .then(content => {
        this.courtagen = content;
        this.loading = false;
      })
      .catch(err => {
        console.log(`GET COURTAGES failed with ${err.status}: ${err.message}`);
        if (this.$store.state.env.environment === 'development') {
          this.courtagen = dummyData;
          this.loading = false;
        } else {
          this.loadingErrorMsg = err.status < 500 ? 'Keine Courtagen gefunden' : CONNECTION_ERROR_MESSAGE;
          this.loadingError = true;
          this.loading = false;
        }
      });
  },
  methods: {
    formatData (courtage) {
      const date = new Date(courtage.courtagedate);
      return Object.assign({}, courtage, {
        year: date.getFullYear(),
        time: date.getTime()
      });
    },
    showYear(year) {
      return this.shownYear === year || (new Date()).getFullYear() === year;
    }
  }
};
</script>
<style>
.courtagen-page .ueberplus {
  margin: 56px 0 40px 0;
  font-size: 24px!important;
}
.courtagen-page .semanticsection-title2 {
  margin-top: 0!important;
  font-size: 20px!important;
  cursor: pointer;
}
.courtagen-page .semanticsection-title2.table-hidden {
  margin-bottom: -16px!important;
}
.courtagen-table {
  width: 100%;
  display: flex;
  justify-content: center;
}
.courtagen-table .v-data-table{
  width: 448px;
}
.courtagen-table td{
  font-size: 16px!important;
  padding-top: 8px!important;
  padding-bottom: 8px!important;
}
.courtagen-table td.courtage-link {
  font-weight: 500!important;
  align-items: center;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}
.courtagen-table td.courtage-link a, .courtagen-table td.courtage-link .v-icon {
  color: rgba(0,0,0,.87) !important;
}
.courtagen-table td.courtage-link:hover a, .courtagen-table td.courtage-link:hover .v-icon {
  color: #0085CF!important;
}
.courtagen-table td.courtage-link .v-icon {
  margin-left: 8px;
  margin-top: -4px;
}
.courtagen-page .year-divider {
  margin: 56px 0 40px;
  height: 2px;
}
.courtagen-page #noDataText {
  font-size: 16px;
  width: 100%;
  text-align: center;
}
</style>
